// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"inputLabel__1STk_"};